import { FormattedMessage } from 'react-intl';
import { InferType, object, string, ref } from 'yup';

import { withPasswordValidation } from '@/shared/config';

export const newPasswordFormSchema = object({
  password: withPasswordValidation(string().required()),
  confirmPassword: string()
    .oneOf([ref('password')], () => (
      <FormattedMessage
        id="signUp.passwordsMustMatch"
        defaultMessage="Passwords must match"
      />
    ))
    .required(),
});

export type NewPasswordFormPayload = InferType<typeof newPasswordFormSchema>;
